var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 212 162",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #e0e4e9;\n      }\n\n      .cls-4 {\n        fill: #637b93;\n      }\n\n      .cls-2 {\n        stroke: #637b93;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 106,
    cy: 81,
    r: 76.54
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 58.51,
    y1: 142.91,
    x2: 75.47,
    y2: 142.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M134.61,142.91c0-10.38,8.42-18.8,18.8-18.8,10.38,0,18.8,8.42,18.8,18.8h10.29c6.21,0,11.25-5.04,11.25-11.25V55.1c0-6.21-5.04-11.25-11.25-11.25H86.72c-6.21,0-11.25,5.04-11.25,11.25v87.81s59.13,0,59.13,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3.95,114.58v28.33s16.96,0,16.96,0c0-10.38,8.42-18.8,18.8-18.8,10.38,0,18.8,8.42,18.8,18.8h16.96s0-74.3,0-74.3h-30.21c-2.98,0-5.85,1.19-7.96,3.3l-26.76,26.76c-4.22,4.22-6.59,9.94-6.59,15.91Zm22.99-19.95l18.43-19.19h23.28v25.81s-39.03-.29-39.03-.29c-3.29-.02-4.95-3.97-2.67-6.34Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 68.65,
    y1: 110.32,
    x2: 59.61,
    y2: 110.32
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 153.4,
    cy: 142.91,
    r: 13.63
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M153.4,130.28c6.96,0,12.63,5.66,12.63,12.63s-5.66,12.63-12.63,12.63-12.63-5.66-12.63-12.63,5.66-12.63,12.63-12.63m0-2c-8.08,0-14.63,6.55-14.63,14.63s6.55,14.63,14.63,14.63,14.63-6.55,14.63-14.63-6.55-14.63-14.63-14.63h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 39.71,
    cy: 142.91,
    r: 13.63
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M39.71,130.28c6.96,0,12.63,5.66,12.63,12.63s-5.66,12.63-12.63,12.63-12.63-5.66-12.63-12.63,5.66-12.63,12.63-12.63m0-2c-8.08,0-14.63,6.55-14.63,14.63s6.55,14.63,14.63,14.63,14.63-6.55,14.63-14.63-6.55-14.63-14.63-14.63h0Z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 208.05,
    y1: 77.69,
    x2: 185.58,
    y2: 77.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 200.97,
    y1: 87.01,
    x2: 178.5,
    y2: 87.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 207.44,
    y1: 96.33,
    x2: 184.97,
    y2: 96.33
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step-2.964d5a8f0237c029b818c5c14bc5780d.svg";
export { ForwardRef as ReactComponent };